<template>
  <div class="app-text">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${options.componentKey}-${i}`"
        class="input-group"
        @click="removeError(i)">

        <el-input
          v-model="valueLocal[i]"
          v-bind="widgetOptions"
          :class="{ 'child-has-error': error[i] }"
          clearable
          :key="`input-${options.componentKey}-${i}`"/>

        <input-example
          :key="`input-example-${options.componentKey}-${i}`"
          :example="options.example"/>

        <div v-if="error[i]" class="ait_message ait_message--error">{{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import approve from 'approvejs';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
    };
  },

  created() {
    if (!this.options.componentKey) this.options.componentKey = 0;
    // Add error messages
    this.validateMessages = Object.assign(
      { email: 'Введите корректный адрес электронной почты!' }, this.validateMessages);

    // Default options
    this.options.email = this.options && this.options.email ? this.options.email : false;

    // Process custom local options of this widget type
    if (this.options.minlength) this.widgetOptions.minlength = this.options.minlength;
    if (this.options.maxlength) this.widgetOptions.maxlength = this.options.maxlength;
    if (this.options.placeholder) this.widgetOptions.placeholder = this.options.placeholder;
    if (!this.options.singleLine) {
      this.widgetOptions.type = 'textarea';
      this.widgetOptions.resize = 'none';
      this.widgetOptions.autosize = true;
    }
  },

  methods: {

    getError() {
      // Validate required
      if (this.options.required) {
        this.valueLocal.forEach((value, i) => {
          const result = approve.value(value, { required: true });
          this.error[i] = result.approved ? '' : this.validateMessages.required;
        });
      }
      // Validate email
      if (this.options.email) {
        this.valueLocal.forEach((value, i) => {
          if (this.error[i]) return;
          const result = approve.value(value, { email: true });
          this.error[i] = result.approved ? '' : this.validateMessages.email;
        });
      }
      this.updateValue();
      return this.error;
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppText.vue